import { render, staticRenderFns } from "./BusOthers.vue?vue&type=template&id=025a72ac&scoped=true"
import script from "./BusOthers.vue?vue&type=script&lang=js"
export * from "./BusOthers.vue?vue&type=script&lang=js"
import style0 from "./BusOthers.vue?vue&type=style&index=0&id=025a72ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025a72ac",
  null
  
)

export default component.exports